module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "WevrMasterAgreement.41ae5d4f.pdf";